"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AutocompleteComponent = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Select = require("../Select");

var _DropDown = require("../DropDown");

var _withNamedError = _interopRequireDefault(require("../withNamedError"));

var _config = require("../config/config");

var AutocompleteComponent =
/*#__PURE__*/
function (_SelectComponent) {
  (0, _inherits2.default)(AutocompleteComponent, _SelectComponent);

  function AutocompleteComponent() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, AutocompleteComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(AutocompleteComponent)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "align", _DropDown.ALIGN_LEFT | _DropDown.ALIGN_BOTTOM | _DropDown.ALIGN_WIDTH);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleFocus", function (e) {
      _this.setState({
        prefix: '',
        input: _this.getLabel()
      });

      e.target.select();
      _this.dropDown && _this.dropDown.show();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onType", function (e, prefix) {
      _this.props.onType && _this.props.onType(e, prefix);

      _this.setState({
        prefix: prefix
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleChange", function (e, value) {
      _this.setState({
        value: undefined,
        input: e.target.value
      });

      _this.onType(e, value !== undefined ? value : e.target.value);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleDropDownHide", function (e) {
      var _this$state = _this.state,
          value = _this$state.value,
          prefix = _this$state.prefix;

      if (prefix && value === undefined) {
        var child = _react.default.Children.toArray(_this.props.children).filter(function (element) {
          return element && element.props;
        }).find(function (element) {
          return prefix.toLowerCase() === element.props.label.toLowerCase();
        });

        if (child) {
          _this.setState({
            value: child.props.value || child.props.label
          });
        }
      }

      _this.setState({
        focus: false
      });

      _this.input && _this.input.blur();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "set", function (e, value) {
      var label = _this.getLabelByValue(value) || value;

      _this.handleChange(e, label);

      _this.setState({
        value: value,
        input: label
      });

      _this.props.onSet && _this.props.onSet(e, value);
    });
    return _this;
  }

  (0, _createClass2.default)(AutocompleteComponent, [{
    key: "getLabel",
    value: function getLabel() {
      var _this$state2 = this.state,
          focus = _this$state2.focus,
          input = _this$state2.input;
      var valueLabel = focus ? input : (0, _get2.default)((0, _getPrototypeOf3.default)(AutocompleteComponent.prototype), "getLabel", this).call(this);
      return valueLabel || '';
    }
  }, {
    key: "getChildrenArray",
    value: function getChildrenArray() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          maxOptionsToShow = _this$props.maxOptionsToShow,
          hasMore = _this$props.hasMore,
          notFoundOptionLabel = _this$props.notFoundOptionLabel,
          typeForMoreElementsOptionLabel = _this$props.typeForMoreElementsOptionLabel,
          showTypeForMore = _this$props.showTypeForMore;

      var items = _react.default.Children.toArray(children).filter(function (element) {
        return element && element.props;
      }).filter(function (element) {
        return _this2.inputFilter(element.props.label);
      }).sort(function (a, b) {
        return a.props.label.toLowerCase() < b.props.label.toLowerCase() ? -1 : 1;
      });

      if (items.length === 0) {
        return [_react.default.createElement(_Select.Option, {
          key: "",
          disabled: true,
          label: notFoundOptionLabel || (0, _config.__)('Not found')
        })];
      }

      if (hasMore || items.length > maxOptionsToShow || showTypeForMore) {
        var label = typeForMoreElementsOptionLabel || (0, _config.__)('... type for more elements');
        return (0, _toConsumableArray2.default)(items.slice(0, maxOptionsToShow)).concat([_react.default.createElement(_Select.Option, {
          key: "type_for_more",
          disabled: true,
          label: label
        })]);
      }

      return items;
    }
  }, {
    key: "inputFilter",
    value: function inputFilter() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var prefix = this.state.prefix || '';
      var inputValue = prefix.trim().toLowerCase();
      var compareValue = value.trim().substr(0, inputValue.length).toLowerCase();
      return compareValue === inputValue;
    }
  }]);
  return AutocompleteComponent;
}(_Select.SelectComponent);

exports.AutocompleteComponent = AutocompleteComponent;
(0, _defineProperty2.default)(AutocompleteComponent, "propTypes", (0, _objectSpread2.default)({}, _Select.SelectComponent.propTypes, {
  onType: _propTypes.default.func,
  onSet: _propTypes.default.func,
  maxOptionsToShow: _propTypes.default.number,
  notFoundOptionLabel: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.string]),
  typeForMoreElementsOptionLabel: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.string]),
  showTypeForMore: _propTypes.default.bool
}));
(0, _defineProperty2.default)(AutocompleteComponent, "defaultProps", {
  maxOptionsToShow: 10
});

var _default = (0, _withNamedError.default)(AutocompleteComponent);

exports.default = _default;